import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../Footer";
import { Link } from "react-router-dom";
import axios from "axios";
import { toTitleCase } from "../helper/formatCarName";
import { SkeletonCard } from "../components/SkeletonLoader";
import CarCard from "../components/CarCard";

const AppRequests = () => {
  const [approvedList, setApprovedList] = useState([]);
  const [contactInfo, setContactInfo] = useState();
  const [pageLoading, setPageLoading] = useState(true);

  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };

  function formatEuroAmount(amount) {
    const parts = amount.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  const storedUserPreferences = getDataFromlocalStorage("userData");

  const fetchData = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/get/accepted/offer/bids",
        {
          owner_id: storedUserPreferences?.id,
        }
      );
      setApprovedList(response?.data.biddings);
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    } finally {
      setPageLoading(false);
    }
  };
  function backto() {
    window.history.back();
  }
  const deleteBid = async (id, userId) => {
    if (window.confirm("Do you realy want to delete this accepted offer!")) {
      try {
        const response = await axios.post(
          window.CARLOCA_API + "/remove/bid",
          {
            owner_id: userId,
            bid_id: id,
          }
        );
        fetchData();
      } catch (error) {
        console.log("An error occurred while fetching data.", error);
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <Navbar />
      <div className="cl-page">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
            <div>
              <h3 className="cl-page-title">Approved Offers</h3>
              <p className="cl-page-subtitle">Cars that have been approved for contact</p>
            </div>
            <button onClick={backto} type="button" className="cl-btn cl-btn-outline cl-btn-sm">
              <i className="fa fa-arrow-left me-1"></i>Back
            </button>
          </div>
          <div className="row g-3">
            {pageLoading ? (
              <SkeletonCard count={8} />
            ) : approvedList?.length === 0 ? (
              <div className="cl-empty">
                <div className="cl-empty-icon"><i className="fa-solid fa-check-circle"></i></div>
                <h6 className="cl-empty-title">No Approved Offers</h6>
                <p className="cl-empty-text">There are currently no approved requests here.</p>
              </div>
            ) : (
              approvedList?.map((car) => (
                <div
                  key={car?.id}
                  className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6"
                >
                  <CarCard
                    carData={car?.car}
                    topLeftContent={
                      <button
                        className="btn btn-sm btn-danger"
                        style={{ border: "none", cursor: "pointer", borderRadius: "6px", padding: "4px 8px" }}
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); deleteBid(car.id, car.bidder?.id); }}
                      >
                        <i className="fa fa-trash" style={{ color: "white", fontSize: "13px" }}></i>
                      </button>
                    }
                    extraBodyContent={
                      <div className="mt-1 pt-1" style={{ borderTop: "1px solid #e5e7eb" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span style={{ fontSize: "11px", color: "#6b7280" }}>From</span>
                          <span className="fw-semibold text-truncate text-end" style={{ fontSize: "11px", color: "#00889c", maxWidth: "55%" }}>
                            {car.bidder.role === "dealer"
                              ? (car.bidder.dealerName || car.bidder.first_name || "Dealer")
                              : car.bidder.role === "user"
                                ? car.bidder.first_name
                                : null}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span style={{ fontSize: "11px", color: "#6b7280" }}>Offer</span>
                          <span className="fw-bold text-truncate text-end" style={{ fontSize: "12px", color: "#00889c", maxWidth: "55%" }}>£{formatEuroAmount(car.amount)}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span style={{ fontSize: "11px", color: "#6b7280" }}>Request</span>
                          <span className="fw-semibold text-capitalize text-truncate text-end" style={{ fontSize: "10px", color: "#00889c", maxWidth: "55%" }}>{car.bid_request}</span>
                        </div>
                        <button
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); setContactInfo(car?.bidder); }}
                          className="btn btn-sm w-100 mt-1"
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal2"
                          style={{ background: "linear-gradient(135deg, #00889c, #006f80)", color: "#fff", padding: "4px", borderRadius: "6px", fontSize: "10px", fontWeight: 600, border: "none" }}
                        >
                          <i className="fa-solid fa-phone me-1"></i>Contact Buyer
                        </button>
                      </div>
                    }
                    hideFooter={true}
                  />
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      <div
          className="modal fade"
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content rounded-0">
              <div className="modal-body ">
                <div id="carouselExample" className="carousel slide">
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <img
                        src="img/slide1.png"
                        className="d-block w-100"
                        alt="..."
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src="img/slide2.png"
                        className="d-block w-100"
                        alt="..."
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src="img/slide3.png"
                        className="d-block w-100"
                        alt="..."
                      />
                    </div>
                  </div>
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExample"
                    data-bs-slide="prev"
                  >
                    <i className="fa-solid fa-chevron-left"></i>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExample"
                    data-bs-slide="next"
                  >
                    <i className="fa-solid fa-chevron-right"></i>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
              <div className="modal-footer border-0 py-1">
                <button
                  type="button"
                  className="btn btn-secondary rounded-0"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="exampleModal2"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel2"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header pb-0">
                <h4>Contact Details</h4>
              </div>
              <div className="modal-body text-center blue mt-3 contact_modal">
                <h5 className="fs-6 text-capitalized">
                  <b>Name - </b>
                  {contactInfo?.role === "dealer" &&
                    contactInfo?.dealerName !== null &&
                    contactInfo?.dealerName !== ""
                    ? contactInfo?.dealerName
                    : contactInfo?.first_name +
                    " " +
                    (contactInfo?.last_name != null &&
                      contactInfo?.last_name !== "null"
                      ? contactInfo?.last_name
                      : "")}
                </h5>
                <h5 className="fs-6 text-capitalized">
                  <b>Contact - </b>
                  {contactInfo?.phone}
                </h5>
                <Link className="blue ">
                  <h5 className="fs-6 text-capitalized">
                    <b>Email - </b>
                    {contactInfo?.email}
                  </h5>
                </Link>
                <div className="mt-4">
                  <a
                    className="btn btn-primary me-2"
                    href={`tel:+${contactInfo?.phone}`}
                  >
                    <i className="fa fa-phone"></i>
                  </a>
                  <a
                    className="btn btn-info text-white"
                    href={`mailto:${contactInfo?.email}`}
                  >
                    <i className="fa fa-envelope"></i>
                  </a>
                </div>
              </div>

              <div className="modal-footer border-0">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

      <Footer />
    </>
  );
};

export default AppRequests;
